<div class="main-wrapper">
  <div class="header">
    <ng-container *ngIf="!util.isMobile()">
      <div class="left-part">
        <div class="content">
          <div class="title">
            {{contentInfo.headerContent.title}}
          </div>
          <div class="sub-title">
            {{contentInfo.headerContent.subTitle}} {{plansName | titlecase}} Plan Is
            <span class="highlighted">{{contentInfo.headerContent.highlighted}}</span>
          </div>
          <div class="desc">
            {{contentInfo.headerContent.desc}}
          </div>
        </div>
      </div>
      <div class="right-part">
        <img src="/assets/images/health-first/hf-shield-thankyou.svg" alt="thank you sheild">
      </div>
    </ng-container>
    <ng-container *ngIf="util.isMobile()">
      <div class="top-content">
        <div class="left-part">
          <div class="title">
            {{contentInfo.headerContent.title}}
          </div>
          <div class="sub-title">
            {{contentInfo.headerContent.subTitle}} {{plansName}} Plan Is
            <span class="highlighted">{{contentInfo.headerContent.highlighted}}</span>
          </div>
        </div>
        <div class="right-part">
          <img src="/assets/images/health-first/hf-shield-thankyou.svg" alt="thank you sheild">
        </div>
      </div>
      <div class="bottom-content">
        <div class="desc">
          {{contentInfo.headerContent.desc}}
        </div>
      </div>
    </ng-container>
  </div>
  <div class="hf-thankyou-steps" *ngIf="!util.isMobile()">
    <ngx-glide [showArrows]="false" [showBullets]="false" [perView]="4" [bound]="true" [gap]="20">
      <div class="slide-item" *ngFor="let item of contentInfo.sliderContent">
        <div class="img-wrapper">
          <img [src]="'/assets/images/health-first/step-' + item.id + '-thankyou.svg'" alt="image"/>
        </div>
        <div class="step-counter">
          STEP: {{item.id}}
        </div>
        <div class="title" [innerHTML]="item?.title">
        </div>
        <div class="download-icon" *ngIf="item.id === 1">
          <a [href]="vars.medibuddyAppLinks.android" target="_blank">
            <img src="/assets/images/health-first/play-store-download.svg" alt="play store" />
          </a>
          <a [href]="vars.medibuddyAppLinks.ios" target="_blank">
            <img src="/assets/images/health-first/App-store-download.svg" alt="play store" />
          </a>
        </div>
        <div class="desc">{{item.desc}}</div>
      </div>
    </ngx-glide>
  </div>
  <div class="hf-thankyou-steps" *ngIf="util.isMobile()">
    <div class="steps-wrapper" *ngFor="let item of contentInfo.sliderContent">
      <div class="img-wrapper" [ngClass]="{'order-2':item.id % 2 === 0}">
        <img [src]="'/assets/images/health-first/step-' + item.id + '-thankyou.svg'" alt="healthfirst steps thankyou image" />
      </div>
      <div class="content">
        <div class="count-title">
          Step {{item.id}}
        </div>
        <div class="title" [innerHTML]="item.title">
        </div>
        <div class="download-icon" *ngIf="item.id === 1">
          <a [href]="vars.medibuddyAppLinks.android" target="_blank" *ngIf="!util.isAppleDevice()">
            <img src="/assets/images/health-first/play-store-download.svg" alt="play store" />
          </a>
          <a [href]="vars.medibuddyAppLinks.ios" target="_blank" *ngIf="util.isAppleDevice()">
            <img src="/assets/images/health-first/App-store-download.svg" alt="app store" />
          </a>
        </div>
        <div class="desc">
          {{item.desc}}
        </div>
      </div>
    </div>
  </div>
</div>